module.exports = __webpack_public_path__ + "static/media/shield.679681bf.svg";